export const LeadMagnetTemplateType = {
  LMTemplateOne: 'LMTemplateOne',
};
